/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { createRoute, Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import EmployeeAssignmentsListPage from 'domain/people/employee/assignments/List';
import { ProtectedRoute } from 'framework/authorization';
import CreateEmployeeAssignment from 'domain/people/employee/assignments/createupdate/Create';
import { CREATE_ASSIGNMENT, UPDATE_ASSIGNMENT } from 'domain/shared/assignment';
import UpdateEmployeeAssignment from 'domain/people/employee/assignments/createupdate/Update';

const useEmployeeAssignmentRoute = () => {
  const routers = createRoute({
    singleEntityRoute: `/:assignmentId`,
    listRoute: `/assignments`,
  });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/copy`,
  };
};

const EmployeeAssignmentsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    createRoute: createEmployeeAssignment,
    updateRoute,
    copyEntityRoute,
  } = useEmployeeAssignmentRoute();

  return (
    <Routes>
      <Route path={listRoute} element={<EmployeeAssignmentsListPage />} />

      <Route
        path={createEmployeeAssignment}
        element={
          <ProtectedRoute permissionToCheck={CREATE_ASSIGNMENT}>
            <CreateEmployeeAssignment />
          </ProtectedRoute>
        }
      />

      <Route
        path={updateRoute}
        element={
          <ProtectedRoute permissionToCheck={UPDATE_ASSIGNMENT}>
            <UpdateEmployeeAssignment />
          </ProtectedRoute>
        }
      />

      <Route
        path={copyEntityRoute}
        element={
          <ProtectedRoute permissionToCheck={CREATE_ASSIGNMENT}>
            <CreateEmployeeAssignment />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default EmployeeAssignmentsRouter;
